import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, Injectable, importProvidersFrom, isDevMode } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, ROUTES, provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { environment } from '../environments/environment';
import { AppConfigService, mainRoute } from './app.config.service';
import { appRoutes } from './app.routes';

import { AXActionSheetService } from '@acorex/components/action-sheet';
import { AXHotkeysService } from '@acorex/components/common';
import { AXDialogService } from '@acorex/components/dialog';
import { AXLoadingService } from '@acorex/components/loading';
import { AXPopupService } from '@acorex/components/popup';
import { AXToastService } from '@acorex/components/toast';
import { AX_DATETIME_CONFIG, dateTimeConfig } from '@acorex/core/date-time';

import { DataConfig, PlatformService } from '@travel/shared/services';
import { HttpErrorInterceptor, httpErrorInterceptor } from '@travel/shared/utilities';

import packageJson from '../../../../package.json';

import { AXTranslation, AXTranslationLoader, AXTranslationLoaderOptions, AXTranslationModule, AX_TRANSLATION_CONFIG, AX_TRANSLATION_LOADER, translationConfig } from '@acorex/core/translation';
import { AXValidationModule } from '@acorex/core/validation';
import { Observable } from 'rxjs';
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

export function initApp(config: AppConfigService) {
  return () => config.load();
}

@Injectable()
export class MyTranslationLoader implements AXTranslationLoader {
  constructor(private http: HttpClient) {}

  getTranslation(options: AXTranslationLoaderOptions): Observable<AXTranslation> {
    return this.http.get<AXTranslation>(`/assets/i18n/${options.lang}/${options.scope}.json`);
  }
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  // anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AX_TRANSLATION_LOADER,
      useClass: MyTranslationLoader,
    },
    // provideClientHydration(
    //   withHttpTransferCacheOptions({
    //     includePostRequests: true,
    //   })
    // ),
    provideHttpClient(withInterceptors([httpErrorInterceptor])),
    provideRouter(appRoutes, inMemoryScrollingFeature),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    PlatformService,
    AXToastService,
    AXActionSheetService,
    AXDialogService,
    AXPopupService,
    AXLoadingService,
    AXHotkeysService,
    importProvidersFrom(AXValidationModule.forRoot(), AXTranslationModule),
    {
      provide: 'environment',
      useValue: environment,
    },
    {
      provide: 'AppConfigService',
      useExisting: AppConfigService,
    },
    {
      provide: 'appVersion',
      useValue: packageJson['version'],
    },
    {
      provide: AX_DATETIME_CONFIG,
      useValue: dateTimeConfig({
        calendar: 'jalali',
      }),
    },
    {
      provide: AX_TRANSLATION_CONFIG,
      deps: [PlatformService],
      useFactory: (_platfromService: PlatformService) => {
        return translationConfig({
          defaultLang: _platfromService.siteLanguage() || 'fa',
          preloadLangs: [_platfromService.siteLanguage() || 'fa'],
          preloadScopes: ['common'],
        });
      },
      // useValue: translationConfig({
      //   // defaultLang: 'fa',
      //   // preloadLangs: ['fa'],
      //   // preloadScopes: ['common'],
      // }),
    },
    {
      provide: AX_DATETIME_CONFIG,
      deps: [PlatformService],
      useFactory: (_platfromService: PlatformService) => {
        if (_platfromService.getUrl()[1] === '') {
          return dateTimeConfig({
          calendar:  DataConfig.get('globalSetting').defaultLanguageCode  !== 'fa' ? 'georgian' : 'jalali',
        })
        }else{
          return dateTimeConfig({
          calendar: _platfromService.siteLanguage() !== 'fa' ? 'georgian' : 'jalali',
        })
        }
        // return dateTimeConfig({
        //   calendar: _platfromService.siteLanguage() !== 'fa' ? 'georgian' : 'jalali',
        // });
      },
    },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initApp, multi: true, deps: [AppConfigService] },
    { provide: ROUTES, useFactory: mainRoute, deps: [PlatformService], multi: true },
  ],
};
